import './league-managers.styles.scss';
import { Link } from 'react-router-dom';
import { recordText } from '@/utils/leagueLabels';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import TeamName from '@/components/SHARED/team-name/team-name.component';

// The teams users manage in a league, with their managers and records.
// teams: summary/teams map. highlightId: the manager's own team.
const LeagueManagers = ({ league, teams, teamLink, highlightId }) => {

    if (!teams) return null;

    const all = Object.values(teams);
    const rows = all
        .filter(t => t.managerId)
        .sort((a, b) => (a.id === highlightId ? -1 : b.id === highlightId ? 1 : 0) ||
            (a.managerName ?? '').localeCompare(b.managerName ?? '') || a.name.localeCompare(b.name));

    return (
        <div className='league-managers'>
            <div className='g-card'>
                <h3>Managers</h3>
                <p className='meta'>
                    {rows.length} of {all.length} teams have a manager. The computer runs the rest.
                </p>
                <div className='table-scroll'>
                    <table className='g-table managers-table'>
                        <thead>
                            <tr>
                                <th>Team</th>
                                <th>Manager</th>
                                <th className='wide-only'>Conference</th>
                                <th className='num'>Record</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(t => (
                                <tr key={t.id} className={t.id === highlightId ? 'highlight' : ''}>
                                    <td>
                                        <Link to={teamLink(t.id)} className='team-link'>
                                            <TeamBadge team={t} size='sm' />
                                            <span><TeamName team={t} /></span>
                                        </Link>
                                    </td>
                                    <td>{t.managerName ?? 'Unknown'}{t.id === highlightId && <span className='meta'> (you)</span>}</td>
                                    <td className='wide-only'>{league.conferences?.[t.conference]?.name ?? ''}</td>
                                    <td className='num'>{recordText(t.record)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default LeagueManagers
